'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

let _=require('pulsar-utils/dist-es6/_');

const AnalyticsAccountId="UA-74554005-3";let

AnalyticsConfig=function(){_createClass(AnalyticsConfig,null,[{key:'$inject',get:function()
{
return['AnalyticsProvider'];
}}]);

function AnalyticsConfig(AnalyticsProvider){_classCallCheck(this,AnalyticsConfig);
let provider=AnalyticsProvider;

if(AnalyticsAccountId==='development'||
!_.exists(window)||
typeof window!='object'||
_.exists(process)&&process.browser!==!0){
provider.
logAllCalls(!0).
enterDebugMode(!0).
enterTestMode(!0).
delayScriptTag(!0);
}else{
provider.
setAccount(AnalyticsAccountId).
logAllCalls(!0).
setPageEvent('$locationChangeSuccess').
trackUrlParams(!0).
trackPages(!0).
ignoreFirstPageLoad(!1);
}
}return AnalyticsConfig}();


module.exports=AnalyticsConfig;
module.exports.runFunction=function(Analytics,$state){
if(!_.exists(window)){
return;
}

const buildEntry=function(title,val){let mapper=arguments.length>2&&arguments[2]!==void 0?arguments[2]:_.identity;
if(!_.exists(val)){
return void 0;
}
return`${title}: ${mapper(val)}`;
};

window.onerror=function(message,file,line,column,error){
const category=`error${_isExternalHost(file)?' (external)':''}`;
const action='unhandled (script)';
const label=_.compact([
buildEntry('MESSAGE',message),
buildEntry('ERROR',error,function(e){return e.stack||e.description||e.message||e}),
buildEntry('FILE',file),
buildEntry('LINE',line),
buildEntry('COLUMN',column),
buildEntry('STATE',$state.current.name),
buildEntry('STATE PARAMS',_.isEmpty($state.params)?void 0:$state.params,function(p){return JSON.stringify(p)})]).
join(' | ').replace(/[\r\n\t]+/g,' -> ').replace(/\s+/g,' ').trim();

Analytics.trackEvent(category,action,label);
};
};

module.exports.runFunction.$inject=['Analytics','$state'];

const _getFileHost=function(file){
const link=window.document.createElement('a');
link.href=file;
return link.hostname;
};

const _isExternalHost=function(file){
const host=_getFileHost(file);

return!(host==window.location.hostname||_.exists(host)||host=='');
};
//# sourceMappingURL=analyticsConfig.js.map
